import { useEffect, useState } from 'react';

/**
 * Shared `viewMode` preference (`grid` | `list`).
 *
 * Persists in `localStorage('listingsViewMode')` and listens for the native
 * `storage` event so changing the toggle on one tab re-renders the other.
 */
const KEY = 'listingsViewMode';

const read = () => {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'list' ? 'list' : 'grid';
  } catch {
    return 'grid';
  }
};

export const useViewMode = () => {
  const [viewMode, setLocal] = useState(read);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === KEY) setLocal(read());
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const setViewMode = (mode) => {
    setLocal(mode);
    try { localStorage.setItem(KEY, mode); } catch { /* ignore */ }
  };

  return [viewMode, setViewMode];
};
